import React from 'react';

const FootballPitch = ({ lineup }) => {
    // Ruta base para los logos de los equipos
    const teamLogoBase = "/img/games/lineup/teams/";

    return (
        <main className="lineup-main">
            <div className="pitch-container">
                <div className="pitch football-pitch">
                    
                    {/* ZONA DE ANOTACIÓN IZQUIERDA (LOCAL) */}
                    <div className="endzone left-zone">
                        <div className="endzone-content">
                            {lineup.leftEndzoneLogoUrl && (
                                <img 
                                    className="endzone-logo" 
                                    src={`${teamLogoBase}${lineup.leftEndzoneLogoUrl}`} 
                                    alt="Local Logo" 
                                />
                            )}
                            {lineup.leftEndzoneText && (
                                <span className="endzone-text">{lineup.leftEndzoneText}</span>
                            )}
                        </div>
                    </div>

                    {/* ZONA DE ANOTACIÓN DERECHA (VISITA) */}
                    <div className="endzone right-zone">
                        <div className="endzone-content">
                            {lineup.rightEndzoneLogoUrl && (
                                <img 
                                    className="endzone-logo" 
                                    src={`${teamLogoBase}${lineup.rightEndzoneLogoUrl}`} 
                                    alt="Visita Logo" 
                                />
                            )}
                            {lineup.rightEndzoneText && (
                                <span className="endzone-text">{lineup.rightEndzoneText}</span>
                            )}
                        </div>
                    </div>

                    {/* Contenedor de Jugadores */}
                    <div className="players-container">
                        {lineup.players.map((p, idx) => (
                            <div key={`${p.playerId}-${idx}`} className="player-card" style={{ left: `${p.positionX}%`, top: `${p.positionY}%` }}>
                                <div className="kit-circle">
                                    {p.dorsal}
                                    {p.isCaptain && <div className="captain-badge">C</div>}
                                </div>
                                <div className="player-info">
                                    <div className="player-name">{p.name}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Head Coach */}
            <div className="dt-card left">
                <div className="kit-circle dt-kit">HC</div>
                <div className="player-info">
                    <div className="player-name">{lineup.managerName?.includes('|') ? lineup.managerName.split('|')[0] : lineup.managerName}</div>
                </div>
            </div>
        </main>
    );
};

export { FootballPitch };